module.exports = __webpack_public_path__ + "media/packs/src/assets/images/google-integration-1-ac624f5715ad9dd3da959f1a8c983343.png";